<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Πληροφορίες HRMS</h4>

            <b-alert show dismissible :variant="alertSettings.variant" v-show="alertSettings.show">{{ alertSettings.msg
            }}</b-alert>

            <b-form @submit.prevent="saveHrms">
              <b-form-group class="mb-3" label="Hrms Username" label-for="horizontal-username-input" label-cols-sm="3">
                <b-form-input id="horizontal-firstname-input" type="text"
                  v-model="hrmsSettings.username"></b-form-input>
              </b-form-group>

              <b-form-group class="mb-4" label="Password" label-for="horizontal-password-input" label-cols-sm="3">
                <b-form-input id="horizontal-password-input" type="text" v-model="hrmsSettings.password"></b-form-input>
              </b-form-group>

              <b-form-group class="mb-4" label="Host" label-for="horizontal-host-input" label-cols-sm="3">
                <b-form-input id="horizontal-host-input" type="text" v-model="hrmsSettings.host"></b-form-input>
              </b-form-group>
              <b-form-group class="mb-4" label="Port" label-for="horizontal-port-input" label-cols-sm="3">
                <b-form-input id="horizontal-port-input" type="text" v-model="hrmsSettings.port"></b-form-input>
              </b-form-group>
              <b-form-group class="mb-4" label="Sid" label-for="horizontal-sot-input" label-cols-sm="3">
                <b-form-input id="horizontal-sid-input" type="text" v-model="hrmsSettings.sid"></b-form-input>
              </b-form-group>

              <div class="form-check mb-4">
                <input class="form-check-input" type="checkbox" id="horizontalLayout-Check"
                  v-model="hrmsSettings.is_active" />
                <label class="form-check-label" for="horizontalLayout-Check">
                  Ενεργό
                </label>
              </div>

              <div class="row justify-content-end">
                <div class="col-sm-9 ms-2">
                  <div>
                    <b-button type="submit" variant="primary" class="me-2">Αποθήκευση</b-button>
                    <b-button variant="success" @click="checkHrms">Έλεγχος Σύνδεσης</b-button>
                  </div>
                </div>
              </div>
            </b-form>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import session from "../../../api/session";
export default {
  page: {
    title: "Ρυθμίσεις HRMS",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Ρυθμισεις HRMS",
      items: [
        {
          text: "Αρχική",
          to: { name: "home" },
        },
        {
          text: "HRMS",
          active: true,
        },
      ],
      hrmsSettings: {
        hrmsID: "",
        username: "",
        password: "",
        host: "",
        port: "",
        sid: "",
        is_active: false,
      },
      action: "",
      alertSettings: {
        msg: "",
        variant: "",
        show: false,
      },
      oracleErrorMsg: "",
    };
  },

  mounted() {
    this.fetchHrms();
  },
  methods: {
    fetchHrms() {
      session.get("api/hrms/hrms-list/").then((resp) => {
        if (resp.data.length > 0) {
          const firstHrms = resp.data[0];
          this.hrmsSettings = {
            hrmsID: firstHrms.id,
            username: firstHrms.username,
            password: firstHrms.password,
            host: firstHrms.host,
            port: firstHrms.port,
            sid: firstHrms.sid,
            is_active: firstHrms.is_active,
          };
          this.oracleErrorMsg = firstHrms.error_msg;
          if (this.oracleErrorMsg != null) {
            this.alertSettings = {
              msg: this.oracleErrorMsg,
              variant: "danger",
              show: true,
            };
          }

          this.action = "update";
        } else {
          this.action = "create";
        }
      });
    },
    saveHrms() {
      if (this.action === "update") {
        session
          .put(
            `api/hrms/${this.hrmsSettings.hrmsID}/actions/`,
            this.hrmsSettings
          )
          .then(() => {
            this.alertSettings = {
              msg: "Ανανεώθηκε επιτυχώς",
              variant: "success",
              show: true,
            };
          })
          .catch((e) => {
            console.log(e.response.data);
            this.alertSettings = {
              msg: `Προέκυψε Σφάλμα! ${Object.entries(e.response.data)}`,
              variant: "danger",
              show: true,
            };
          });
      }
      if (this.action === "create") {
        session
          .post("api/hrms/create-hrms/", this.hrmsSettings)
          .then(() => {
            this.alertSettings = {
              msg: "Ανανεώθηκε επιτυχώς",
              variant: "success",
              show: true,
            };
          })
          .catch((e) => {
            this.alertSettings = {
              msg: `Προέκυψε Σφάλμα! ${Object.entries(e.response.data)}`,
              variant: "danger",
              show: true,
            };
          });
      }
    },
    checkHrms() {
      session.get("api/hrms/check-connection/").then((resp) => {
        if (resp.data) {
          this.alertSettings = {
            msg: "Η σύνδεση είναι επιτυχής",
            variant: "success",
            show: true,
          }
        }
        else {
          this.alertSettings = {
            msg: `Ανεπιτυχής Σύνδεση`,
            variant: "danger",
            show: true,
          };
        }
      }
      )
    }
  },
};


</script>
